import Vue from 'vue'
import store from '@/store'
import route from '@/router'

let sessionInterval = null
let counter = 0

function initSessionInterval () {
  if (sessionInterval !== null) {
    deleteInterval()
  }
  interval()
}

export function tokenTimeLeft (expTime) {
  const expiracyTime = expTime
  const currentTime = Date.now()
  const timeLeft = (expiracyTime - currentTime) / 1000 / 60
  return timeLeft
}

function interval () {
  sessionInterval = setInterval(async () => {
    counter++
    if (counter === 2) { await store.dispatch('refreshToken') }
    if (counter === 4) { sessionAlmostDoneModal() }
    if (counter === 5) {
      forceSessionLogout()
    }
  }, 60000)
}

function deleteInterval () {
  counter = 0
  clearInterval(sessionInterval)
}

function sessionAlmostDoneModal () {
  Vue.swal({
    type: 'warning',
    title: '',
    text: 'Tu sesión expirará en 1 minuto. ' +
      'Pulsa el botón para continuar en esta sesión',
    showCloseButton: false,
    showConfirmButton: true,
    confirmButtonColor: '#00ba68',
    confirmButtonText: 'Continuar en esta sesión',
    onClose: () => {
      initSessionInterval()
    }
  })
}

function forceSessionLogout () {
  store.dispatch('signout')
  Vue.swal({
    type: 'info',
    title: '',
    text: 'Tu sesión expiró. ' +
      'Pulsa el botón para iniciar sesión nuevamente',
    showCloseButton: false,
    showConfirmButton: true,
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonColor: '#00ba68',
    confirmButtonText: 'Volver a iniciar sesión',
    cancelButtonText: 'Cancelar'
  })
    .then((result) => {
      if (result.value) { route.push({ name: 'LogIn' }) }
    })
}

export {
  initSessionInterval,
  deleteInterval,
  forceSessionLogout
}



// WEBPACK FOOTER //
// ./src/session/session.js